<template>
  <div v-if='!item'>
    <v-container>
      <wc-loading line></wc-loading>
    </v-container>
  </div>
  <div v-else>
    <wc-page-title :title='title' :subtitle='subtitle'>
      <template v-slot:rightSide>
         <wc-archive-button v-if='item' :isArchived='item.archived' @toggleArchive='toggleArchive'></wc-archive-button>
       </template>
    </wc-page-title>
    <v-container v-if='item.archived'>
      <v-alert border='bottom' type='error'>This item is archived</v-alert>
    </v-container>
    <router-view
      :item='item'
      @update='updateItem'
    ></router-view>
  </div>
</template>

<script>
import assetsAPI from '@/modules/assets/api/services'

export default {
  name: 'services-base',
  data: () => ({
    isLoading: true,
    item: null
  }),
  computed: {
    title () {
      if (this.item) {
        return this.item.description
      }
      return ''
    },
    subtitle () {
      if (this.item) {
        return '#' + this.item.number
      }
      return ''
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.item = await assetsAPI.getServiceItem(this.$route.params.id)
      this.isLoading = false
    },
    async updateItem (item) {
      this.item = await assetsAPI.updateServiceItem(item)
    },
    toggleArchive () {
      this.item.archived = !this.item.archived
      this.updateItem (this.item)
    }
  }
}
</script>